"use client";

import { ChevronLeft, ChevronRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
import { PLACEMENTS_DATA } from "@/data/placementDetails";
import Image from "next/image";

const Placements = () => {
  return (
    <div className="page-container py-10 md:py-12">
      <div className="flex items-center justify-between mb-2">
        <h2
          className="text-2xl sm:text-3xl lg:text-4xl font-bold text-black"
          style={{ fontFamily: "saans-bold" }}
        >
          Student Placement Highlights
        </h2>
        <div className="hidden md:flex gap-3">
          <button
            className="prev-btn cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
            aria-label="Previous"
          >
            <ChevronLeft className="w-5 h-5 text-gray-700" />
          </button>
          <button
            className="next-btn cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
            aria-label="Next"
          >
            <ChevronRight className="w-5 h-5 text-gray-700" />
          </button>
        </div>
      </div>

      <p className="text-sm md:text-base lg:text-lg text-black leading-relaxed w-full md:w-[80%] lg:w-[70%] mb-6">
        Each placement reflects a student’s journey from learning skills in
        classrooms and labs to applying them in real workplaces. These
        highlights share how students grow in confidence, gain industry
        exposure, and take their first steps into meaningful professional roles.
      </p>

      <Swiper
        modules={[Navigation]}
        spaceBetween={16}
        loop={true}
        slidesPerView={1.3}
        navigation={{
          prevEl: ".prev-btn",
          nextEl: ".next-btn",
        }}
        breakpoints={{
          640: { slidesPerView: 1.3 },
          768: { slidesPerView: 2.3 },
          1024: { slidesPerView: 3.3 },
          1280: { slidesPerView: 4 },
        }}
        className="career-swiper w-full"
      >
        {PLACEMENTS_DATA.map(({ name, title, companyLogo, image }, index) => (
          <SwiperSlide
            key={index}
            className="flex flex-col items-center bg-white"
          >
            <div className="relative w-full aspect-[3/4] overflow-hidden">
              <Image
                src={image}
                alt={name}
                fill
                className="object-cover object-top w-full h-full"
                priority
              />
              <div
                className="absolute bottom-0 left-0 right-0 h-full w-full flex flex-col justify-end px-4 py-4 text-left"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(8, 30, 45, 0) 45.54%, rgba(8, 30, 45, 0.8) 91.22%)",
                }}
              >
                <h3 className="font-bold text-white text-[18px]">{name}</h3>
                <p className="text-white text-xs text-[15px]">{title}</p>
              </div>
            </div>

            <div className="w-full flex justify-center items-center h-full py-5 border border-[rgba(205,226,235,1)]">
              {companyLogo && (
                <Image
                  src={companyLogo}
                  alt={`${name} company logo`}
                  width={120}
                  height={60}
                  className="h-[40px] md:h-[35px] w-auto"
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Mobile Navigation Buttons */}
      <div className="flex md:hidden justify-center gap-3 mt-6">
        <button
          className="prev-btn cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
          aria-label="Previous"
        >
          <ChevronLeft className="w-5 h-5 text-gray-700" />
        </button>
        <button
          className="next-btn cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
          aria-label="Next"
        >
          <ChevronRight className="w-5 h-5 text-gray-700" />
        </button>
      </div>
    </div>
  );
};

export default Placements;
